var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 33499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93339 2.7873C8.16498 2.18168 7.05789 2.18168 6.28949 2.7873L2.56347 5.72396C2.24213 5.97722 2.05588 6.35535 2.05588 6.75448V11.5495C2.05588 12.2859 2.67771 12.8828 3.44477 12.8828H11.7781C12.5452 12.8828 13.167 12.2859 13.167 11.5495V6.75448C13.167 6.35535 12.9807 5.97722 12.6594 5.72396L8.93339 2.7873ZM5.40819 1.75678C6.68886 0.747415 8.53401 0.747416 9.81469 1.75678L13.5407 4.69343C14.1834 5.19995 14.5559 5.95623 14.5559 6.75448V11.5495C14.5559 13.0223 13.3122 14.2162 11.7781 14.2162H3.44477C1.91065 14.2162 0.666992 13.0223 0.666992 11.5495V6.75448C0.666992 5.95622 1.0395 5.19995 1.68217 4.69343L5.40819 1.75678Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 55",
    d: "M15.333 8.00024V6.66691H12.6663V8.00024H15.333ZM12.6663 8.00024C12.6663 8.68586 12.6829 9.2331 12.6922 9.65672C12.7019 10.0978 12.7024 10.3705 12.6838 10.5856C12.6581 10.8832 12.6099 11.0701 12.2619 11.5395L14.4041 13.1276C14.9783 12.3531 15.2635 11.7067 15.3406 10.8152C15.3733 10.4358 15.3676 10.0252 15.3582 9.59807C15.3484 9.15356 15.333 8.64796 15.333 8.00024H12.6663ZM12.2619 11.5395C12.1501 11.6903 11.8948 11.8877 10.9879 11.9725C10.0603 12.0594 8.93594 12.0002 7.33301 12.0002V14.6669C8.73008 14.6669 10.1446 14.7298 11.2364 14.6276C12.349 14.5235 13.5936 14.2209 14.4041 13.1276L12.2619 11.5395Z",
    fill: "#5256FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56",
    d: "M6.33301 13.5498H8.99967",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56_2",
    d: "M13.1551 8.00024C13.1551 8.39298 13.4735 8.71136 13.8662 8.71136C14.2589 8.71136 14.5773 8.39298 14.5773 8.00024H13.1551ZM14.5773 8.00024V6.66691H13.1551V8.00024H14.5773Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7778 10.6668C12.0107 10.6668 11.3889 11.2638 11.3889 12.0002C11.3889 12.7365 12.0107 13.3335 12.7778 13.3335C13.5448 13.3335 14.1667 12.7365 14.1667 12.0002C14.1667 11.2638 13.5448 10.6668 12.7778 10.6668ZM10 12.0002C10 10.5274 11.2437 9.3335 12.7778 9.3335C14.3119 9.3335 15.5556 10.5274 15.5556 12.0002C15.5556 13.4729 14.3119 14.6668 12.7778 14.6668C11.2437 14.6668 10 13.4729 10 12.0002Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.78e0d51480144cab3a99f717662282ec.svg";
export { ForwardRef as ReactComponent };